import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContractsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Contracts",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17.143 14.302h-6.857a1.143 1.143 0 0 1 0-2.287h6.857a1.143 1.143 0 0 1 0 2.287M21.725 9.616h-11.43a1.143 1.143 0 0 1 0-2.286h11.43a1.143 1.143 0 0 1 0 2.286"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 29.715H8a3.433 3.433 0 0 1-3.429-3.43V5.716A3.433 3.433 0 0 1 8 2.284h16a3.433 3.433 0 0 1 3.429 3.43v20.57A3.433 3.433 0 0 1 24 29.716M8 4.572c-.63 0-1.144.512-1.144 1.142v20.572c0 .63.513 1.142 1.144 1.142h16c.63 0 1.144-.512 1.144-1.142V5.714c0-.63-.513-1.142-1.144-1.142z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.225 25.145c-.482 0-.955-.12-1.37-.356-.5-.285-.829-.636-1.039-1.015-.208.364-.43.688-.673.931a1.4 1.4 0 0 1-1.569.294 1.425 1.425 0 0 1-.858-1.38c.142-3.151-.365-3.984-.68-4.201a.48.48 0 0 0-.556-.006c-.26.211-1.051.856-1.051 4.384a1.143 1.143 0 1 1-2.285 0c0-4.09 1.012-5.44 1.894-6.158.93-.754 2.284-.796 3.291-.105.914.628 1.359 1.736 1.557 2.983.338-.644.635-1.059 1.053-1.297.144-.082.305-.131.47-.146.667-.055 1.075.269 1.25.468.518.586.366 1.303.233 1.935-.218 1.028-.138 1.194.095 1.327a.6.6 0 0 0 .508-.001c.452-.193.857-.885 1.11-1.897a1.143 1.143 0 0 1 2.217.553c-.556 2.228-1.628 3.104-2.428 3.446-.376.16-.776.24-1.17.24m-4.702-2.053v.002zm3.665-1.973"
    })]
  }));
};
ContractsIcon.displayName = 'ContractsIcon';